import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.sendEvent === 'function') {
      window.sendEvent('pageview', {
        page_path: location.pathname
      });
    }
  }, [location.pathname]);
}
